export const COMPANY_SUMMARY_SPREADSHEET_COLUMN_KEY_PREFIX = 'security';
export const COMPANY_SUMMARY_SPREADSHEET_COLUMN_NAME = 'Column';
export const COMPANY_SUMMARY_SPREADSHEET_COLUMN_NAME_PLURAL = 'Columns';
export const COMPANY_SUMMARY_SPREADSHEET_TITLE = 'Summary Holdings';
export const COMPANY_SUMMARY_SPREADSHEET_SLUG = 'company-summary';
export const COMPANY_SUMMARY_SPREADSHEET_TABLE = `${COMPANY_SUMMARY_SPREADSHEET_SLUG}-table`;
